module.exports = __webpack_public_path__ + "static/media/bus.4da86c1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bus.png
// module id = 1988
// module chunks = 0